import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Development">
                            <h2>Expedite Your Development And Minimize Your Time To Market</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>With our minimum viable product(MVP) development services, our careful techniques allow you to progress steadily by building the product with the essential features and covering all the necessary aspects of the development lifecycle.</p>
                       <p>At TekRevol, we develop systems that help you progress better and ensure overall sustainability. Our expert-level advice can be the next breakthrough for your digital product in the years to come.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;